// src/Components/Countdown.js
import React, { useCallback, useState, useEffect } from 'react';
import { EVENT_COUNTDOWN_TARGET } from "../constants/eventDetails";

const Countdown = ({ targetDate = EVENT_COUNTDOWN_TARGET }) => {
  const [timeLeft, setTimeLeft] = useState({});
  const hasTargetDate = Boolean(targetDate);

  const getTimeLeft = useCallback(() => {
    const now = new Date();
    const endTime = new Date(targetDate);
    const difference = endTime - now;

    if (difference <= 0) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60)
    };
  }, [targetDate]);

  useEffect(() => {
    if (!hasTargetDate) {
      return undefined;
    }

    setTimeLeft(getTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [getTimeLeft, hasTargetDate]);

  if (!hasTargetDate) {
    return (
      <div id="countdown" className="countdown-inner d-flex gap-2 w-100">
        <div className="time m-auto py-4 text-center w-100">
          <span
            className="lh-1 fw-bold gradient-text"
            style={{ fontSize: "clamp(30px, 4vw, 44px)", display: "block" }}
          >
            TBA
          </span>
          <p
            className="text-uppercase fw-semibold mb-0"
            style={{ fontSize: "10px", letterSpacing: "0.15em", color: "#6B7280", marginTop: "6px" }}
          >
            Schedule
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      id="countdown"
      className="countdown-inner d-flex gap-2 w-100"
    >
      {[
        { id: 'days',    val: timeLeft.days,    label: 'Days' },
        { id: 'hours',   val: timeLeft.hours,   label: 'Hours' },
        { id: 'minutes', val: timeLeft.minutes, label: 'Minutes' },
        { id: 'seconds', val: timeLeft.seconds, label: 'Seconds' },
      ].map(({ id, val, label }) => (
        <div key={id} className="time m-auto py-3 text-center">
          <span
            id={id}
            className="lh-1 fw-bold gradient-text"
            style={{ fontSize: 'clamp(28px, 4vw, 42px)', display: 'block' }}
          >
            {String(val ?? 0).padStart(2, '0')}
          </span>
          <p className="text-uppercase fw-semibold mb-0" style={{ fontSize: '10px', letterSpacing: '0.15em', color: '#6B7280', marginTop: '6px' }}>
            {label}
          </p>
        </div>
      ))}
    </div>
  );
};

export default Countdown;
